<template>
  <div class="icp-footer">
    <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
      津ICP备2021001502号-5
    </a>
  </div>
</template>

<script>
export default {
  name: 'IcpFooter'
}
</script>

<style scoped>
.icp-footer {
  text-align: center;
  font-size: 12px;
  color: #909399;
  padding: 8px 0;
}
.icp-footer a {
  color: inherit;
  text-decoration: none;
}
.icp-footer a:hover {
  text-decoration: underline;
}
</style>
